import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { Card } from "react-bootstrap";
import { Editor } from "primereact/editor";
import { FormSelectField } from "../../../../../partials/content/Forms/FormField";

function QuotationTOC({
  quotationTOCs = [],
  customerTOCDefault = false,
  handleCustomerTOCDefault,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [tocOptions, setTOCOptions] = useState([]);
  useEffect(() => {
    setTOCData(quotationTOCs);
  }, [quotationTOCs]);
  return (
    <Card>
      <Card.Header>
        <i className="fas fa-sticky-note"></i>
        <span>
          <strong>Terms & Conditions</strong>
        </span>
      </Card.Header>
      <Card.Body>
        <div className="row mb-3">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <FormSelectField
              label="Predefined Terms & Conditions Name"
              name="tocName"
              options={tocOptions}
              onSelectChange={(tocValue) => {
                setFieldValue("tocName", tocValue);
                setFieldValue("toc", tocValue.toc);
              }}
            />
          </div>
        </div>
        <Editor
          style={{ height: "200px", width: "100%" }}
          onTextChange={(e) => {
            setFieldValue("toc", e.htmlValue);
          }}
          value={values.toc}
          placeholder="Type your terms & conditions here..."
        />
      </Card.Body>
    </Card>
  );
  function setTOCData(quotationTOCs = []) {
    let tocOptionsTmp = [];
    tocOptionsTmp.push({
      value: {
        tocName: {},
        toc: "",
      },
      label: "No Reference",
    });
    if (typeof quotationTOCs !== "undefined") {
      quotationTOCs.map((quotationTOC, index) => {
        if (quotationTOC.defaultTOC === true) {
          tocOptionsTmp.push({
            value: quotationTOC,
            label: quotationTOC.title + " (Default)",
          });
          if (customerTOCDefault === true) {
            setFieldValue("tocName", quotationTOC);
            setFieldValue("toc", quotationTOC.toc);
            handleCustomerTOCDefault();
          }
        } else {
          tocOptionsTmp.push({
            value: quotationTOC,
            label: quotationTOC.title,
          });
        }
      });
    }
    setTOCOptions(tocOptionsTmp);
  }
}

export default QuotationTOC;
